function Sale(){
    return(
        <div></div>
    )
}
export default Sale;